import { NavLink, Outlet, useLocation } from "react-router-dom";
import { BarChart3, FileEdit, CalendarClock, RefreshCcw, Settings2 } from "lucide-react";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";

export const CAMPAIGN_NAV = [
  ["/admin/campaign", "Overview & Analytics", BarChart3, true],
  ["/admin/campaign/templates", "Template Builder", FileEdit],
  ["/admin/campaign/campaigns", "Campaign & Schedule", CalendarClock],
  ["/admin/campaign/logs", "Delivery Logs & Resend", RefreshCcw],
  ["/admin/campaign/settings", "Integration Settings", Settings2],
];

export default function CampaignLayout() {
  const { pathname } = useLocation();
  const current = [...CAMPAIGN_NAV].reverse().find(([to]) => pathname.startsWith(to));
  const isNew = pathname.endsWith("/new");
  return (
    <div data-testid="campaign-module">
      <Breadcrumb className="mb-4" data-testid="campaign-breadcrumbs">
        <BreadcrumbList>
          <BreadcrumbItem><BreadcrumbLink href="/admin">CMS</BreadcrumbLink></BreadcrumbItem><BreadcrumbSeparator />
          <BreadcrumbItem>Marketing Tools</BreadcrumbItem><BreadcrumbSeparator />
          <BreadcrumbItem><BreadcrumbLink href="/admin/campaign">Campaign Blasting</BreadcrumbLink></BreadcrumbItem><BreadcrumbSeparator />
          <BreadcrumbItem>{isNew ? <BreadcrumbLink href="/admin/campaign/campaigns">{current?.[1]}</BreadcrumbLink> : <BreadcrumbPage>{current?.[1]}</BreadcrumbPage>}</BreadcrumbItem>
          {isNew && <><BreadcrumbSeparator /><BreadcrumbItem><BreadcrumbPage>New Blast</BreadcrumbPage></BreadcrumbItem></>}
        </BreadcrumbList>
      </Breadcrumb>
      <div className="mb-8">
        <p className="eyebrow mb-2">Marketing Tools · Multi-Channel Proposal Manager</p>
        <h1 className="text-2xl font-bold tracking-tight text-[#0F2B48] sm:text-3xl">Campaign Blasting</h1>
      </div>
      <nav className="mb-8 flex gap-2 overflow-x-auto rounded-xl border border-slate-200 bg-white p-2 shadow-sm" data-testid="campaign-subnav">
        {CAMPAIGN_NAV.map(([to, label, Icon, end]) => (
          <NavLink key={to} to={to} end={end} data-testid={`campaign-nav-${to.split("/").pop()}`}
            className={({ isActive }) => `flex shrink-0 items-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold transition-colors ${isActive ? "bg-[#0F2B48] text-white" : "text-slate-600 hover:bg-slate-100 hover:text-[#0F2B48]"}`}>
            <Icon size={16} /> {label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
